import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Modal from "@/components/Modal.vue";
import SelectList from "@/components/SelectList.vue";
import { useVendor } from "@/composables/vendor";
import { useVendorsQuery } from "@/utils/operations";


export default /*#__PURE__*/_defineComponent({
  props: {
  open: Boolean,
},
  emits: ["update:open"],
  setup(__props, { emit }) {





const { vendors, setVendor, currentVendor } = useVendor();

const onClose = () => {
  if (currentVendor.value) emit("update:open", false);
};

const setVendorAndClose = (vendor: any) => {
  setVendor(vendor);
  emit("update:open", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: __props.open,
    onClose: onClose,
    class: "max-w-sm w-full"
  }, {
    default: _withCtx(() => [
      _createVNode(SelectList, {
        modelValue: _unref(currentVendor),
        "onUpdate:modelValue": setVendorAndClose,
        items: _unref(vendors),
        "get-title": (v) => v.shortname,
        "get-description": (v) => v.name
      }, null, 8, ["modelValue", "items", "get-title", "get-description"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})